import { render, staticRenderFns } from "./TdCategory.vue?vue&type=template&id=61d7af0c&scoped=true&"
import script from "./TdCategory.vue?vue&type=script&lang=js&"
export * from "./TdCategory.vue?vue&type=script&lang=js&"
import style0 from "./TdCategory.vue?vue&type=style&index=0&id=61d7af0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d7af0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VList,VMenu,VRow})
